import { useContext } from "react";
import { FlashMessengerContext } from "../features/uikit/FlashMessenger/FlashMessengerProvider";
export default function useFlashMessenger() {
    return useContext(FlashMessengerContext);
}
